const defaultState = {
  'language': 'ja',
  'currency': 'jpy'
}

export default function items(state = defaultState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
